import Vue from 'vue'
import Router from 'vue-router'

import Asset from './pages/asset'
import Default from './pages/default'

Vue.use(Router)

export const defaultRoutes = {
  assets: {
    path: '/content/*',
    component: Asset
  },
  default: {
    path: '*',
    component: Default
  }
}

export const defaultRouterOptions = {
  mode: 'history',
  routes: Object.values(defaultRoutes),
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
}

export function createRouter () {
  return new Router(defaultRouterOptions)
}
